/**
 * Created by staffanrantzow on 30/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
export class SelectBox extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    required: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    classes: PropTypes.string,
    callback: PropTypes.func.isRequired,
    disabled: PropTypes.string,
    showErrorWithoutBlur: PropTypes.bool.isRequired,
    options: PropTypes.array,
    label: PropTypes.string
  };

  constructor (props) {
    super(props);

    this.state = {
      value: this.props.value ? this.props.value : '',
      valid: false,
      required: this.props.required === 'true',
      isBlurred: false,
      disabled: this.props.disabled === 'true',
      showErrorWithoutBlur: this.props.showErrorWithoutBlur
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount () {
    this.validate();
  }

  /**
   * Called when user clicks the submit button
   * @param nextProps
   */
  componentWillReceiveProps (nextProps) {
    this.setState({showErrorWithoutBlur: nextProps.showErrorWithoutBlur});
  }

  onChange (e) {
    this.setState({
      value: e.target.value
    }, function () {
      this.validate();
    });
  }

  validate () {
    var valid = true;

    for (var i = 0; i < this.props.options.length; i++) {
      if (this.props.options[i].value === this.state.value && this.props.options[i].disabled) {
        valid = false;
        break;
      }
    }

    this.setState({valid: valid}, function () {
      this.sendValueToParent();
    });
  }

  sendValueToParent () {
    this.props.callback(this.props.name, {
      value: this.state.value,
      valid: this.state.valid
    });
  }

  render () {
    var classes, errorClasses, disabled, options;

    classes = this.props.classes ? 'input-wrapper ' + this.props.classes : 'input-wrapper';
    /* Only show the error if the user has blurred the field or the parent
    forces the error to show (which happens when user clicks submit) */
    errorClasses = !this.state.valid &&
      (this.state.isBlurred || this.state.showErrorWithoutBlur) ? 'error show' : 'error';
    options = [];

    // Create the options
    for (var i = 0; i < this.props.options.length; i++) {
      disabled = {};
      if (this.props.options[i].disabled) {
        disabled['disabled'] = 'disabled';
      }
      options.push(<option value={this.props.options[i].value} key={i}
        {...disabled}>{this.props.options[i].key}</option>);
    }

    return (
      <div className={classes}>
        <div className='styled-select'>
          <select value={this.state.value} name={this.props.name} onChange={this.onChange}>
            {options}
          </select>
          {this.renderLabel()}
        </div>
        <p className={errorClasses}>{this.props.errorMessage}</p>
      </div>
    );
  }

  renderLabel () {
    if (this.props.label) {
      return (
        <label htmlFor={this.props.name}>{this.props.label}</label>
      );
    }
  }
}

export default SelectBox;



/** WEBPACK FOOTER **
 ** ./src/components/select-box/select-box.js
 **/